import React from 'react'
import { Tooltip, InfoOutlineIcon } from 'src/ui'

// Available commodities for futures trading
export const availableCommodities = [
  'Ethanol',
  'Corn',
  'Soybean',
  'Soybean Oil',
  'Soybean Meal',
  'Spring Wheat',
  'Wheat',
  'Hard Red Wheat',
  'Hard Red Spring Wheat (CME: HRS)',
  'Oats',
  'Milo',
  'Canola',
  'Cotton',
  'Rice',
  'Live Cattle',
  'Feeder Cattle',
  'Lean Hogs',
  'Crude Oil',
  'Heating Oil',
  'Milk Class III',
  'Milk Class IV',
  'Cheese Cash Settled',
  'Butter Cash Settled',
  'Nonfat Dry Milk',
  'Dry Whey',
  'Canadian Dollar',
  'US Dollar Index',
]

// Products that are restricted by the CME and require special approval
export const restrictedProducts = ['Crude Oil', 'Heating Oil', 'Canadian Dollar']

// Helper function to check if a product is restricted
export const isRestrictedProduct = (productName: string): boolean => {
  return restrictedProducts.includes(productName)
}

export const RestrictedProductTooltip = ({ productName }: { productName: string }) => {
  if (isRestrictedProduct(productName)) {
    return (
      <Tooltip
        label="Due to CME restrictions, do not enable unless approved by Benny/Lacey/Andrew"
        aria-label="CME Restriction Warning"
        placement="top"
      >
        <InfoOutlineIcon color="orange.500" transform="translateY(-4px)" />
      </Tooltip>
    )
  }
  return null
}
